import React, { useRef } from 'react'
import useIsClonedSlide from './use-is-cloned-slide'
import VideoPoster from './video-poster'
import YouTube from './youtube'
import Vimeo from './vimeo'

const PLAYERS = { youtube: YouTube, vimeo: Vimeo }

// A 16:9 video area. Only the current, non-cloned slide mounts a live
// player; everything else shows a poster, so leaving the slide destroys the
// player and stops playback.
const VideoSlide = ({ slide, active, onPlay, onPause, onEnded }) => {
  const ref = useRef(null)
  const cloned = useIsClonedSlide(ref)
  const { video } = slide
  const Player = PLAYERS[video.service]
  const live = active && !cloned && Player

  return (
    <div ref={ref} className='w-full h-full text-white relative min-h-full'>
      <div className='relative w-full h-full bg-gray-900 dark:bg-gray-900 aspect-[4/2.75] sm:aspect-video'>
        {live ? (
          <Player
            videoId={video.id}
            autoplay={Boolean(video.autoplay)}
            title={slide.title}
            onPlay={onPlay}
            onPause={onPause}
            onEnded={onEnded}
          />
        ) : (
          <VideoPoster image={slide.image} video={video} title={slide.title} />
        )}
      </div>
    </div>
  )
}

export default VideoSlide
